<template>
  <div>
    <!--This is the phone navigation drawer, for desktop see file: Layout.vue-->
    <v-app-bar-nav-icon large class="black--text pt-1 pr-0" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-navigation-drawer absolute right v-model="drawer" app overlay-color="grey lighten-3" width="100%">
      <v-list>
        <v-list-item>
          <!--Example avatar-->
          <v-list-item-avatar>
            <v-img src="/wenewz_middle_2color.svg"></v-img>
          </v-list-item-avatar>
          <!--User Name-->
          <v-list-item-content>
            <v-list-item-title class="title text-center">{{ fullName }}</v-list-item-title>
          </v-list-item-content>
          <v-btn icon @click="closeDrawer()" color="error">
            <v-icon large>far fa-times-circle</v-icon>
          </v-btn>
        </v-list-item>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <!--Not Logged in Content-->
        <div v-if="!isLoggedIn">
          <v-list-item v-for="item in notLoggedIn" :key="item.name" router :to="item.route" class="pl-8 pt-5">
            <v-list-item-action>
              <v-icon class="black--text" large>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="black--text" title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <!--Logged in Content-->
        <div v-else>
          <!--Is logged in and on Front page-->
          <div v-if="!isUserPage">
            <v-list-item v-for="item in loggedInFront" :key="item.name" router :to="item.route" class="pl-8 pt-5">
              <v-list-item-action>
                <v-icon class="black--text" large>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="black--text" title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
          <!--Is logged in and on private pages-->
          <div v-else>
            <v-list-item v-for="item in loggedInPrivate" :key="item.name" router :to="item.route" class="pl-8 pt-5">
              <v-list-item-action>
                <v-icon class="black--text" large>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="black--text" title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <!-- <v-list-item route :to="'/front'" class="pt-5">
              <v-list-item-action>
                <v-icon class="black--text" large>fas fa-home</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="black--text" title>To the frontpage</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </div>
        </div>
      </v-list>
      <!--Log out button at the end-->
      <template v-slot:append >
        <div class="pa-12" v-if="isLoggedIn">
          <v-btn class="ma-0 pa-0" block color="primary" :to="'/logout'">Logout</v-btn>
        </div>
        <div>
          <v-img src="../erasmusLogo.jpg" height="50px" contain ></v-img>
          <v-img src="/jltLogo.png" height="50px" style="background-color: grey;" contain></v-img>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
// Function imported from vuex
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      // Setting a v-model to the drawer, and making it false (not open), by default
      drawer: false,
      // Content displayed when not logged in
      notLoggedIn: [
        { icon: "fas fa-home", name: "Login", route: { name: "login" } },
        { icon: "far fa-address-card", name: "Register", route: { name: "register" }},
      ],
      // Content displayed on front page
      loggedInFront: [
        // { icon: "", name: "Dashboard", route: { name: "dashboard" } },
        { icon: "", name: "User profile", route: { name: "editprofile" } },
        {
          icon: "",
          name: "Frontpage setting",
          route: { name: "editfrontpagesettings" }
        },
        { icon: "", name: "Your articles", route: { name: "listarticles" } },
        { icon: "", name: "Create article", route: { name: "createarticle" } },
        // { icon: '', name: 'Inbox', route: { name: "inbox" }},
        { icon: "", name: "Log out", route: "/logout" }
        // { icon: '', name: 'Follows', route: { name: "follows" }},
      ],
      // Content displayed on private pages
      loggedInPrivate: [
        // { icon: "", name: "Dashboard", route: { name: "dashboard" } },
        { icon: "", name: "To the frontpage", route: "/front" },
        { icon: "", name: "User profile", route: { name: "editprofile" } },
        {
          icon: "",
          name: "Frontpage setting",
          route: { name: "editfrontpagesettings" }
        },
        { icon: "", name: "Your articles", route: { name: "listarticles" } },
        { icon: "", name: "Create article", route: { name: "createarticle" } }
        // { icon: '', name: 'Inbox', route: { name: "inbox" }},
        // { icon: '', name: 'Follows', route: { name: "follows" }},
        // { icon: '', name: 'Log out', route: '/logout'},
      ]
    };
  },
  methods: {
    closeDrawer() {
      this.drawer = false;
    }
  },
  computed: {
    ...mapGetters(["isLoggedIn", "fullName", "updateStatus", "getLang"]),
    isUserPage() {
      return (
        // this.$route.name === "dashboard" ||
        this.$route.name === "listarticles" ||
        this.$route.name === "editprofile" ||
        this.$route.name === "createarticle" ||
        this.$route.name === "profilesettings" ||
        this.$route.name === "editfrontpagesettings" ||
        this.$route.name === "inbox" ||
        this.$route.name === "follows" ||
        this.$route.name === "managefeeds" ||
        this.$route.name === "editarticle"
      );
    }
  }
};
</script>
